import React, { useCallback } from 'react'
import { GuidedTour } from '@e3dc-react/shell/Elements/GuidedTour'
import { useDashboardTourSteps } from './hooks/use-dashboard-tour-steps'
import { useUserSettings } from 'src/Hooks'
import { useDashboardTour } from './DashboardTourProvider'

/**
 * Renders the guided tour for the dashboard if it is enabled.
 *
 * It reads the current tour running state from context, loads the tour steps,
 * and disables the guided tour in user settings when the tour completes.
 */
export const DashboardGuidedTour: React.FC = () => {
  const { tour, setTourRunning } = useDashboardTour()

  const dashboardTourGuideSteps = useDashboardTourSteps()

  const { updateUserSettings } = useUserSettings()

  const handleTourFinish = useCallback(() => {
    updateUserSettings({ showGuidedTour: false })
    setTourRunning(false)
  }, [updateUserSettings, setTourRunning])

  return <GuidedTour steps={dashboardTourGuideSteps} run={tour.isRunning} onTourComplete={handleTourFinish} scrollingEnabled />
}
